<template>
  <highcharts :options="chartOptions"></highcharts>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  name: 'LineChart',
  data () {
    return {
      usersFields: {
        '0': {
          label: 'User',
          sortable: true
        },
        '1': {
          label: 'Replies',
          sortable: true
        },
        '2': {
          label: 'Closed',
          sortable: true
        },
        '3': {
          label: 'Customers Helped',
          sortable: true
        }
      },
      usersStats: [],
      customersHelped: 0,
      repliesPerDay: 0,
      closedMessages: 0,
      chartData: {
        categories: [],
        data: []
      }
    }
  },
  created () {
    this.getData()
  },
  computed: {
    ...mapGetters(['currentReportMailbox', 'reportDates']),
    chartOptions: function () {
      return {
        title: {
          text: 'Customers Helped'
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        xAxis: {
          categories: this.chartData.categories
        },
        series: [{
          name: 'Customers Helped',
          data: this.chartData.data
        }]
      }
    }
  },
  methods: {
    getTeamReport () {
      var vm = this
      this.$http.get('/team_stats', {params: {mailbox: this.currentReportMailbox.id, start_date: this.reportDates.startDate, end_date: this.reportDates.endDate}})
        .then(function (response) {
          vm.usersStats = response.data.users
          vm.customersHelped = response.data.customers_helped
          vm.closedMessages = response.data.closed_messages
          vm.repliesPerDay = response.data.replies_per_day
          vm.chartData.categories = response.data.chart_data.categories
          vm.chartData.data = response.data.chart_data.data
        })
        .catch(e => { console.log(e) })
    },
    getData () {
      if (this.currentReportMailbox.id) {
        this.getTeamReport()
      }
    }
  },
  watch: {
    currentReportMailbox () {
      this.getData()
    },
    reportDates () {
      this.getData()
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/admin/reports/LineChart.vue